<template>
	<div class="nav">
		<!--<a href="#/" >
			<img v-bind:src="'https://static.qxiu.com/h5/static/icon-home'+ (index==0?'-hover':'') +'.png'"/>
			<p v-bind:class="index==0?'hover':''">首页</p>
		</a>
		<a href="javascript:void(0)" v-on:click="toCare">
			<img v-bind:src="'https://static.qxiu.com/h5/static/icon-care'+ (index==1?'-hover':'') +'.png'"/>
			<p v-bind:class="index==1?'hover':''">关注</p>
		</a>
		<a href="javascript:void(0)" v-on:click="toCenter">
			<img v-bind:src="'https://static.qxiu.com/h5/static/icon-center'+ (index==2?'-hover':'') +'.png'"/>
			<p v-bind:class="index==2?'hover':''">我的</p>
		</a>-->
		<div class="download dataReport" v-on:click="loadDown" v-if="showDown && showLabel && index==0 && !isxiaoxiong" data-place="34">
			<img src="../../img/dating/app.png"/>
			<div class="describ">
				<p>更精彩 更清晰 更流畅</p>
				<span>进入APP直播间获得更多体验</span>
			</div>
			<div class="btn">下载</div>
			<span v-on:click="closeLabel"></span>
		</div>
	</div>
</template>

<script>
	import { mapState } from 'vuex'
	import passPort from '../../libs/passport'
	import cookie from '../../libs/cookie'
	export default {
		name: 'navBot',
		data(){
			return {
				showLabel: true,
				showDown: true
			}
		},
		props:['index'],
		computed:{
			isxiaoxiong(){
				return cookie.get('isxiaoxiong')=='true'
			},
		},
		mounted() {
			var u = navigator.userAgent,
			isGooglePlay = !!u.match(/_GM_/); //googlePlay手Q终端
			if(isGooglePlay){
				this.showDown = false;
			}
		},
		methods:{
			toCare(){
				if(passPort.isLogin()){
					location.hash="/care"
				}else{
					this.$store.commit('getCurview', 'loginmode')
				}
			},
			toCenter(){
				if(passPort.isLogin()){
					location.hash="/center"
				}else{
					this.$store.commit('getCurview', 'loginmode')
				}
			},
			loadDown() {
			},
			isWeixin() {
				var ua = window.navigator.userAgent.toLowerCase();
				if(ua.match(/MicroMessenger/i) == 'micromessenger') {
					return true;
				} else {
					return false;
				}
			},
			closeLabel(e){
				this.showLabel = false;
				e.stopPropagation();
			},
		}
	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
	
	
	
	.nav{
		/*position: absolute;*/
		position: fixed;
		bottom: 0rem;
		width: 15rem;
		/*padding: 0.4rem 0 1.6rem;*/
		background: #fff;
		text-align: center;
		border-top: 1px solid #E9E9E9;
	}
	
	@media only screen and (device-width: 375px) and (device-height:812px) and (-webkit-device-pixel-ratio:3) {
	    .nav{
			bottom: -1rem;
		}
	}
	.nav a{
		display: inline-block;
		width: 32%;
		vertical-align: middle;
		color: #6D6D6D;
		font-size: 0.4rem;
		
	}
	.nav a img{
		height: 0.74rem;
	}
	.nav a p.hover{
		color: #000;
	}
	.nav .download{
		width: 15rem;
		height: 2.4rem;
		/*background: url(../../img/dating/downloadApp.png);*/
		background: rgb(254,94,155);
		position: absolute;
		top: -2.4rem;
	}
	.download >img{
		float: left;	
		width: 1.6rem;
		height: 1.6rem;
		margin: 0.4rem 0.32rem 0;
	}
	.download .describ{
		float: left;
		color: #fff;
		font-size: 0.44rem;
		text-align: left;
	}
	.download .describ p{
		margin-top: 0.35rem;
		font-size: 0.76rem;
	}
	.download .btn{
		position: absolute;
		top: 0.52rem;
		right: 1.32rem;
		width: 3.2rem;
		height: 1.32rem;
		border-radius: 0.66rem;
		background: #fff;
		line-height: 1.32rem;
		font-size: 0.48rem;
		color: rgb(254,94,155);;
	}
	.download>span{
		position: absolute;
		top: 0.96rem;
		right: 0.32rem;
		width: 0.72rem;
		height: 0.66rem;
		background: url(../../img/dating/close.png) no-repeat;
		background-size: contain;
	}
	
</style>


// WEBPACK FOOTER //
// navBottom.vue?1a7d9e52